import type { ComponentType } from 'react'
import * as d1 from './diagrams'
import * as d2 from './diagrams2'
import * as d3 from './diagrams3'

/**
 * Visual registry. Scene content names a visual by id; this maps ids to components,
 * so copy and visuals stay independently editable.
 */
export const visuals: Record<string, ComponentType> = {
  /* Opening */
  cover: d1.Cover,

  /* Team */
  'leadership-grid': d3.LeadershipGrid,
  'architect-profile': d2.ArchitectProfile,
  'profile-renato': d3.ProfileRenato,
  'profile-marcos': d3.ProfileMarcos,
  'profile-samuel': d3.ProfileSamuel,
  'profile-dylan': d3.ProfileDylan,
  'team-grid': d2.TeamGrid,
  'team-alignment': d3.TeamAlignment,
  'expertise-matrix': d2.ExpertiseMatrix,
  'reference-cards': d2.ReferenceCards,
  'eam-expertise': d1.EamExpertise,

  /* EAM */
  'strategic-property': d3.StrategicProperty,
  'eam-questions': d3.EamQuestions,
  'eam-extended': d3.EamExtended,
  'disciplines-compare': d3.DisciplinesCompare,
  'eam-discipline': d1.EamDiscipline,
  'eam-model': d1.EamModel,
  'property-example': d3.PropertyExample,
  'eam-lifecycle-value': d1.EamLifecycleValue,

  /* Challenge */
  'lifecycle-overview': d1.LifecycleOverview,
  'outcome-cards': d1.OutcomeCards,
  'system-landscape': d1.SystemLandscape,
  'lifecycle-continuity': d1.LifecycleContinuity,
  'before-after': d1.BeforeAfter,
  'evaluation-weights': d1.EvaluationWeights,

  /* Solution */
  'product-concept': d1.ProductConcept,
  'application-map': d1.ApplicationMap,
  'property-workspace': d1.PropertyWorkspace,
  'acquisition-flow': d1.AcquisitionFlow,
  'management-flow': d1.ManagementFlow,
  'disposition-flow': d1.DispositionFlow,
  'gis-snap-layout': d1.GisSnapLayout,
  'work-task-workspace': d1.WorkTaskWorkspace,
  'desktop-mobile': d1.DesktopMobile,

  /* Products */
  'studio-runtime-operations': d1.StudioRuntimeOperations,
  'product-studio': d3.ProductStudio,
  'product-runtime': d3.ProductRuntime,
  'product-operations': d3.ProductOperations,

  /* Architecture */
  'architecture-glance': d3.ArchitectureGlance,
  'integration-map': d3.IntegrationMap,
  'platform-object': d1.PlatformObject,
  'technical-stack': d1.TechnicalStack,
  'event-pipeline': d1.EventPipeline,
  'security-chain': d1.SecurityChain,
  'gis-architecture': d1.GisArchitecture,
  'ai-pipeline': d1.AiPipeline,
  'application-package': d1.ApplicationPackage,

  /* Delivery & support */
  'scrum-cycle': d3.ScrumCycle,
  'outcomes-grid': d3.OutcomesGrid,
  'support-model': d3.SupportModel,
  'severity-sla': d3.SeveritySla,
  'program-timeline': d2.ProgramTimeline,
  'sprint-roadmap': d2.SprintRoadmap,
  'milestone-rail': d2.MilestoneRail,
  'stakeholder-map': d2.StakeholderMap,
  'migration-pipeline': d2.MigrationPipeline,
  'risk-matrix': d2.RiskMatrix,
  'support-continuum': d2.SupportContinuum,

  /* Investment */
  'support-investment': d3.SupportInvestment,
  'investment-cards': d2.InvestmentCards,
  'payment-rail': d2.PaymentRail,
  'deliverable-categories': d2.DeliverableCategories,
  accountability: d2.Accountability,

  /* Closing */
  'closing-lifecycle': d2.ClosingLifecycle,
}

export function Visual({ id }: { id: string }) {
  const Component = visuals[id]
  if (!Component) {
    return (
      <div className="visual-missing" role="note">
        Visual <code>{id}</code> is not yet implemented.
      </div>
    )
  }
  return <Component />
}
